// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-map[data-v-36f458dc]{display:flex;flex-direction:column;align-items:center;position:relative}.wf-map-caption[data-v-36f458dc]{position:absolute;bottom:32px;max-width:1366px;color:var(--text);background-color:var(--yellow-50)}@media(max-width:575px){.wf-map-caption[data-v-36f458dc]{font-size:1.2rem;bottom:0;padding-top:1rem}}", ""]);
// Exports
module.exports = exports;
